<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<AttachedFileTargetSearchSection
				:query="q"
				:target_type="targetType"
				@search-targets="searchTargets"
			/>
			<v-divider class="mt-4" />
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="items"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
					@click:row="openShowPage"
				/>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import AttachedFileTargetSearchSection from "./components/AttachedFileTargetSearchSection.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		AttachedFileTargetSearchSection,
	},
	data() {
		return {
			title: "添付ファイル閲覧",
			targetType: "matter",
			items: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				// TODO
			},
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		if (this.$route.query.target_type) this.targetType = this.$route.query.target_type
		this.setQuery()
		this.fetchTargets(this.q, page)
	},
	methods: {
		fetchTargets(q, page) {
			const headers = authenticate.setHeader()
			const params = { page, q, target_type: this.targetType }
			axios
				.get("/erp/v1/attached_files/targets", {
					params,
					headers,
				})
				.then((res) => {
					this.items = res.data.items.map((item, i) => {
						item.product_number = `2023X-0000${i+1}`
						return item
					})
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchTargets(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { target_type: this.targetType, page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchTargets(q, targetType) {
			this.targetType = targetType
			this.q = q
			this.fetchTargets(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { target_type: this.targetType, ...this.q, page: 1 },
			})
		},
		openShowPage(item) {
			this.$router.push({
				name: "attached_file_show",
				params: { id: item.id, type_id: this.targetType },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page" && query_key != "targetType") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
	computed: {
		headers() {
			if (this.targetType == "matter") {
				return [
					{ text: "確度", value: "situation", width: "80px" },
					{ text: "案件名", value: "name", width: "200px" },
					{ text: "見積番号", value: "quotation_number", width: "200px" },
					{ text: "受注番号", value: "order_number", width: "200px" },
					{ text: "受注元", value: "regular_customer_company.name", width: "200px" },
					{ text: "納入先", value: "delivery_company_name", width: "200px" },
					{ text: "工事名", value: "construction.name", width: "200px" },
				]
			} else if (this.targetType == "matter_product") {
				return [
					{ text: "製造番号", value: "product_number", width: "150px" },
					{ text: "製品名", value: "product.name", width: "150px" },
					{ text: "数量", value: "quantity", width: "80px" },
					{ text: "受注元", value: "matter.regular_customer_company.name", width: "100px" },
					{ text: "納入先", value: "matter.delivery_company_name", width: "100px" },
				]
			}
		},
	},
}
</script>
